import React, { Component } from 'react';
import uuid from 'uuid';
import PropTypes from 'prop-types';

const stateInicial = {
    cita : {
        cliente: "",
        contacto: "",
        mensaje: "",
        fecha: ""
    },
    error: false
}

class Form extends Component {
    state = { ...stateInicial }
    // leer datos
    // read data
    handleChange = e => {
        // console.log(e.target.name + ": " + e.target.value);
        // guardar datos del usuario
        // save user's data
        this.setState({
            cita: {
                ...this.state.cita,
                [e.target.name] : e.target.value
            }
        })
    }
    // enviar datos del formulario
    // send data from the form
    handleSubmit = e => {
        e.preventDefault();
        // extraer datos del state
        // extract state's data
        const { cliente, contacto, mensaje, fecha } = this.state.cita;
        // validar si estan vacios
        // validate if are empties
        if ( /^\s+$/.test(cliente) || /^\s+$/.test(contacto) || /^\s+$/.test(mensaje) || /^\s+$/.test(fecha) || cliente ==="" || contacto ==="" || mensaje ==="" || fecha ==="") {
            console.log("Todos los campos son obligatorios");
            this.setState({
                error: true
            })
            return;
        }
        // datos para enviar
        // data to send
        const nuevaCita = {...this.state.cita};
        nuevaCita.id = uuid();
        // enviar datos al state de APP
        // send the data to the state's APP
        this.props.agendarCita(nuevaCita);
        // reiniciar state y formularios
        // reset state and form
        this.setState({
            ...stateInicial
        });
    }

    render() {
        // validar si hay errores
        // validate if there is errors
        const { error } = this.state;        
        return (
            <form 
                onSubmit={this.handleSubmit}
            >
            {error ? 
                <div className="alert alert-danger">Todos los campos son obligatorios</div>  
            : null}
                <div className="form-group">
                    <input
                        onChange={this.handleChange}
                        value={this.state.cita.cliente} 
                        name="cliente" 
                        type="text" 
                        className="form-control" 
                        placeholder="Cliente" />
                </div>
                <div className="form-group">
                    <input
                        onChange={this.handleChange}
                        value={this.state.cita.contacto} 
                        name="contacto" 
                        type="text" 
                        className="form-control" 
                        placeholder="Contacto" />
                </div>
                <div className="form-group">
                    <input
                        onChange={this.handleChange}
                        value={this.state.cita.mensaje} 
                        name="mensaje" 
                        type="text" 
                        className="form-control" 
                        placeholder="Descripción o mensaje"/>
                </div>
                <div className="form-group">
                    <input
                        onChange={this.handleChange}
                        value={this.state.cita.fecha} 
                        name="fecha" 
                        type="date" 
                        className="form-control" 
                        placeholder="Fecha"/>
                </div>
                <button 
                    type="submit" 
                    className="btn text-white btn-block" 
                >Agendar</button>
            </form>
        );
    }
}

Form.propTypes = {
    agendarCita : PropTypes.func.isRequired 
}

export default Form;